module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00022.0942e367.jpg";